import { useEffect, useState } from "react";
import { Row, Col, Form, Input, MainModal, Button } from './../../ui/ot'
import { useTranslation } from "react-i18next";
const VerifyRejctForm = ({
    propsForm = null,
    formReloadCount = 0,
    onFormFinish = () => { },
    keyPrefix = "hrms.sop_display"
}) => {
    const { t } = useTranslation("translation", { keyPrefix: keyPrefix })
    const [form] = Form.useForm();
    const onFinish = (values) => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldsValue();
        } else {
            formValues = form.getFieldsValue();
        }
        onFormFinish({
            ...formValues,
        });
    };

    const onValuesChange = (value, { name, type }) => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldsValue();
        } else {
            formValues = form.getFieldsValue();
        }
    };

    useEffect(() => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldsValue();
        } else {
            formValues = form.getFieldsValue();
        }
    }, [formReloadCount]);
    return (
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Form.Item
                        label={`${t('patch')}${t('reason')}`}
                        name={"reason"}
                    >
                        <Input />
                    </Form.Item>
                </Form>
            </Col>
        </Row>
    );
}

const VerifyRejctButton = ({
    handleOnClick = () => { },
    keyPrefix = "hrms.sop_display"
}) => {
    const { t } = useTranslation("translation", { keyPrefix: keyPrefix })
    return <>
        <Button onClick={handleOnClick}>{t('review')}</Button>
    </>
}
const VerifyRejctModal = ({
    propsForm,
    onFormFinish = () => { },
    propsOpen,
    propsSetOpen,
    PropsForm,
    keyPrefix,
    extraElement=<></>
}) => {
    const [form_] = Form.useForm();
    const form = propsForm ?? form_
    const [open_, setOpen_] = useState(false);
    const open = propsOpen ?? open_
    const setOpen = propsSetOpen ?? setOpen_
    const VerifyRejctForm_ = PropsForm ?? VerifyRejctForm
    return <>
        <MainModal
            axiosMode="patch"
            propsForm={form}
            propsOpen={open}
            propsSetOpen={setOpen}
            onFinish={onFormFinish}
            width={1000}
            formElement={<VerifyRejctForm_ />}
            keyPrefix={keyPrefix}
        />
    </>
}

const useVerifyRecject = () => {
    const [open, setOpen] = useState(false)
    return {
        open,
        setOpen,
        VerifyRejctForm,
        VerifyRejctModal,
        VerifyRejctButton
    }
}
export default useVerifyRecject